var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userDataLoadingStatus == 'loaded')?_c('task-framework',{attrs:{"showModal":true,"taskId":Number(_vm.$route.params.taskid),"selfSigned":_vm.selfSigned}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }